import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WhatsAppWebSettings from "./WhatsAppWebSettings";

// Opened from the WhatsApp Webchat card on the Integrations page. Closing it unmounts the form, so reopening reads fresh settings.
const WhatsAppWebDialog = ({ open, onClose, workspaceId, onChanged }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { bgcolor: "background.paper" } }}>
    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      WhatsApp Webchat
      <IconButton onClick={onClose} size="small">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <WhatsAppWebSettings workspaceId={workspaceId} onChanged={onChanged} />
    </DialogContent>
  </Dialog>
);

export default WhatsAppWebDialog;
